import { StoreState } from '../../reducers';

export const selectUnreadServicingCount = (state: StoreState): number =>
  state.unreadAppointmentsCount;
